import React from 'react'
import { Dialog } from '@headlessui/react'
import { selectFontStyle } from '../../../../../CommonComponent/SelectFontStyle'

export default function PreviewFaqModal({setIsFaqOpen, isFaqOpen, auctionData}) {
    return (
        <Dialog open={isFaqOpen} onClose={() => setIsFaqOpen(false)}
            className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#282828cc]"
            style={{fontFamily: selectFontStyle(auctionData.font['body_font'])}}
            id="exampleModalXl2"
            tabIndex="-1"
            aria-labelledby="exampleModalXlLabel"
            aria-modal="true"
            role="dialog">
            <Dialog.Panel
                className="pointer-events-none mx-5 relative flex min-h-[calc(100%-1rem)] w-auto
                items-center transition-all duration-300 ease-in-out min-[740px]:mx-auto
                min-[740px]:min-h-[calc(100%-3.5rem)] min-[740px]:max-w-[658px]">
                <div
                    className="pointer-events-auto relative flex w-full flex-col rounded-md border-none 
                    bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <Dialog.Title
                        className="flex flex-shrink-0 border-b border-[#A1A1A9] items-center justify-between rounded-t-md p-4">
                        <p className="text-[22px] text-[#343434] leading-normal pl-3">FAQs</p>
                        {/* <!--Close button--> */}
                        <button data-testid="close_faq"
                            onClick={()=>{setIsFaqOpen(false)}}
                            type="button"
                            className="box-content rounded-none border-none"
                            aria-label="Close">
                            <img src="/images/CloseButton-modalcontent.svg" alt="img" loading="lazy" />
                        </button>
                    </Dialog.Title>
                    {/* <!--Modal body--> */}
                    <div id='faq-modal' className="relative my-2 ">
                        <div id='faq-modal1' className="relative p-4 sm:mx-8 mx-2.5 mt-2 mb-5">
                            <div className="h-[330px] pr-6 overflow-y-auto overflow-x-hidden customScrollbar">
                                {auctionData?.faq?.map((faq, index) => (
                                    <div className='mb-4' key={index}>
                                        <p className="text-[#343434] text-[14px] leading-normal font-bold">
                                            {faq.question}</p>
                                        <p className="text-[#343434] text-[14px] leading-normal pt-3">
                                            {faq.answer} 
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog.Panel>
        </Dialog>  
    )
}
